export default __webpack_public_path__ + "static/media/markdown-cheatsheet-online.cd50fde6.pdf";